import { toast } from 'react-toastify'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress';
import { register, reset } from '../features/auth/authSlice'


import Snackbar from '@mui/material/Snackbar';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Alert from '@mui/material/Alert';


import FormControlLabel from '@mui/material/FormControlLabel';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";


function Register() {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password2: '',
  })

  const { name, email, password, password2 } = formData

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const theme = createTheme();


  const { user, isLoading, isError, isSuccess, message } = useSelector(
    (state) => state.auth
  )

  useEffect(() => {
    if (isError) {
      toast.error(message)
    }

    if (isSuccess || user) {
      navigate('/admin')
    }

    dispatch(reset())
  }, [user, isError, isSuccess, message, navigate, dispatch])


  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  const onSubmit = (e) => {
    e.preventDefault()
    console.log(password)

      if (password !== password2) {
        toast.error('Passwords do not match')
      } else {
        const userData = {
          name,
          email,
          password,
        }

        dispatch(register(userData))
      }
  }


  return (
    <>

      <ThemeProvider theme={theme}>

      <Container component="main" maxWidth="xs">

      <Box component="form" noValidate   onSubmit={onSubmit} sx={{ mt: 3 }}>
      <h1>
         Register
      </h1>
      {
        isLoading && <Box sx={{ display: 'flex' }}>
        <CircularProgress />
        </Box>
      }
        <Grid container spacing={2}>

        <Grid item xs={12}>
           <TextField
             required
             type='name'
             className='form-control'
             id='name'
             name='name'
             defaultValue="Name"
             onChange={onChange}
             fullWidth
             autoComplete="name"

           />

         </Grid>

         <Grid item xs={12}>
            <TextField
              required
              type='email'
              id='email'
              name='email'
              defaultValue="Email"
              onChange={onChange}
              fullWidth
              autoComplete="email"

            />

          </Grid>


          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              type='password'
              name="password"
              label="password"
              onChange={onChange}
              id="password"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              type='password'
              name="password2"
              label="password2"
              onChange={onChange}
              id="password2"
            />
          </Grid>
          <Grid item xs={12}>

          </Grid>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}

        >
          Login
        </Button>

      </Box>
      </Container>
    </ThemeProvider>


    </>
  )
}

export default Register
